import { shared } from './shared'
import type { Schema } from './types'

export const schema: Schema = {
  ...shared,
  'basket-add-a-gift-note': {
    default: true,
  },
  'basket-personalised-promotions': {
    default: true,
  },
  'ecards-xsell': {
    default: true,
  },
  'payment-options-show-browser-pay': {
    default: true,
  },
  'loyalty-plus-show-savings': {
    default: true,
  },
  'loyalty-plus-x-sell-modal-v2': {
    default: true,
  },
}
